var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountingAdjustment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M24.2 36.3H12.1c-3.1 0-5.7-2.5-5.7-5.7V10c0-3.1 2.5-5.7 5.7-5.7h15.7c3.1 0 5.7 2.5 5.7 5.7v7.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M18.4 11.3h8M13.4 24.3h7M13.4 17.8h13"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.4,
    cy: 11.3,
    r: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.8 22.2s-2.1-1.4-4.2-1c-2.6.5-3.3 3.4-1 4.9.1.1.3.1.4.2 1.7.9 3.4.5 4.6 1.4 1.4 1 2.2 4.1-.9 5.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.5 37.3s2.1 1.4 4.2 1c2.7-.5 3.3-3.7.6-5.1-1.7-.9-3.4-.5-4.6-1.4-1.4-1-2.3-4.1.9-5.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingAdjustment);
export default __webpack_public_path__ + "static/media/accountingAdjustment.1330c0195ac88f8951c3dec7ca7a1c55.svg";
export { ForwardRef as ReactComponent };